import { Button } from '@material-ui/core';
import { getLoanById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { NotificationsDialog } from '@/components/modules/Notifications/components/NotificationsWidget/components/NotificationsDialog';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';

export const NotificationsWidget = () => {
  const { loanId } = useParams();
  const { opened, setOpened, toggleDialog } = useDialog();

  if (!loanId) return <></>;

  const { data: loan } = useCache(getLoanById, { loanId: loanId });

  if (!loan) return <></>;

  return (
    <>
      <Button onClick={() => toggleDialog()}>
        <Font variant={'subtitle2'} color={'textSecondary'}>
          <i
            className={'material-icons-outlined mr-2'}
            style={{ verticalAlign: '-5px', marginLeft: '-4px', fontSize: '1.5em' }}
          >
            notifications
          </i>
          <Text tId={'NOTIFICATIONS'} />
        </Font>
      </Button>
      {opened && <NotificationsDialog loan={loan} opened={opened} setOpened={setOpened} />}
    </>
  );
};
